import React, { useContext, useState } from "react";
import { filtrationcontext } from "../../context/Filtercontext";
import trans from "../../utils";
import Searchbar from "../Helpers/Searchbar/Searchbar";
import { InputSelect } from "../Helpers/Input/RefactoredInput";
import { useGetAllSkusQuery } from "../../Redux/service/Sku/Sku";
import { useGetModelsByProductQuery } from "../../Redux/service/CallCenter/CallCenter";
import { requestStatus } from "../../constants";

const STATUS_OPTIONS = requestStatus
	.filter((s) => s.value !== "none")
	.map((s) => ({ label: trans(s.label), value: s.value }));

export default function CallCenterHead({ filter, setFilter }) {
	const { setSearchQuery } = useContext(filtrationcontext);

	const [query, setQuery] = useState("");
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};

	const { data: skusData, isFetching: productsLoading } = useGetAllSkusQuery();
	const productOptions = (skusData?.data || []).map((s) => ({
		label: s.skuName,
		value: String(s.id),
	}));

	const selectedProductIds = filter.skuId?.join(",") || undefined;
	const { data: modelsData, isFetching: modelsLoading } =
		useGetModelsByProductQuery(selectedProductIds);
	const modelOptions = modelsData?.options || [];

	return (
		<div className="bg-white p-16 d-flex align-items-baseline gap-3">
			<Searchbar
				style="search search-dark input-group"
				path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
				placeholder={trans("Search")}
				value={query}
				onChange={handleSearch}
			/>

			<InputSelect
				placeholder={trans("Product")}
				options={productOptions}
				mode="multiple"
				loading={productsLoading}
				value={filter.skuId}
				onChange={(value) =>
					setFilter((prev) => ({ ...prev, skuId: value || [], modelId: [] }))
				}
				formstyle="flex-grow-1 text-capitalize"
			/>
			<InputSelect
				placeholder={trans("Model")}
				options={modelOptions}
				mode="multiple"
				loading={modelsLoading}
				value={filter.modelId}
				onChange={(value) =>
					setFilter((prev) => ({ ...prev, modelId: value || [] }))
				}
				formstyle="flex-grow-1 text-capitalize"
			/>
			<InputSelect
				placeholder={trans("Status")}
				options={STATUS_OPTIONS}
				mode="multiple"
				value={filter.status}
				onChange={(value) =>
					setFilter((prev) => ({ ...prev, status: value || [] }))
				}
				formstyle="flex-grow-1 text-capitalize"
			/>
		</div>
	);
}
